/* eslint-disable */
export default {
  participants: 'Participants',
  host: '(Hôte)',
  removeParticipant: 'Retirer un participant',
  removeTitle: 'Retirer un participant',
  removeDescription: 'Retirer {name} de cette conférence ?',
  confirmButtonText: 'Retirer',
  cancelButtonText: 'Annuler',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
